<template>
  <article>
    <v-layout 
      v-if="mostrarNewFeatures"
      id="persistInfo"
      class="panel"
      :class="'darkBlue'"
      align-center
      justify-center
      row
      fill-height
    >
      <div class="message deftColor">
        Agora você pode fazer o
        <strong>Fechamento Mensal</strong> de uma forma mais fácil e simples!
      </div>

      <div class="link deftColor" @click="$router.push('/fechamento')">Venha conhecer</div>
      <v-tooltip bottom>
        <v-btn slot="activator" icon dark @click.native="desativarNewFeature()">
          <v-icon color="red">close</v-icon>
        </v-btn>
        <span>Fechar essa notificação</span>
      </v-tooltip>
    </v-layout>
    <v-layout 
      v-if="sefazLentidao"
      id="persistInfo"
      class="panel"
      :class="'red'"
      align-center
      justify-center
      row
      fill-height
    >
      <div class="message deftColor">
        <strong>SEFAZ</strong> está com lentidão e quedas repentinas, ocasionando uma demanda maior de espera para consultar <strong>NF-e</strong> e <strong>CT-e</strong>, agradecemos a compreensão!
      </div>
      <!-- <div class="link deftColor" @click="$router.push('/fechamento')">Venha conhecer</div> -->
      <v-tooltip bottom>
        <v-btn slot="activator" icon dark @click.native="desativarNewFeature()">
          <v-icon color="red">close</v-icon>
        </v-btn>
        <span>Fechar essa notificação</span>
      </v-tooltip>
    </v-layout>
    <v-layout 
      v-if="prefSpLentidao"
      id="persistInfo"
      class="panel"
      :class="'red'"
      align-center
      justify-center
      row
      fill-height
    >
      <div class="message deftColor">
        <strong>Prefeitura de SP</strong> está com lentidão e quedas repentinas, ocasionando uma demanda maior de espera para consultar <strong>NFs-e</strong>, agradecemos a compreensão!
      </div>
      <!-- <div class="link deftColor" @click="$router.push('/fechamento')">Venha conhecer</div> -->
      <v-tooltip bottom>
        <v-btn slot="activator" icon dark @click.native="desativarNewFeature()">
          <v-icon color="red">close</v-icon>
        </v-btn>
        <span>Fechar essa notificação</span>
      </v-tooltip>
    </v-layout>
    <v-layout
      v-if="config.show"
      id="persistInfo"
      class="panel"
      :class="this.config.color"
      align-center
      justify-center
      row
      fill-height
    >
      <div class="message deftColor">{{config.msg}}</div>

     <div
        v-if="config.link.has"
        class="link deftColor"
        @click="$router.push(config.link.url)"
      >{{config.link.msg}}</div>
      <div
        v-if="config.link.has && config.link.msg && (
          String(config.msg).includes('Certificado') || String(config.msg).includes('certificado')
        )"
        
        class="redirectAgendaDiv"
      >
      <v-btn href="https://agendaonline.gerencert.app?T-5a6f64C-8a0193A-626df1F-2P-14" target="_blank">Renove Agora! Apenas R$ 140,00</v-btn>
      </div>
    </v-layout>

    <v-layout 
    v-if="InformacaoSefaz"
      id="persistInfo"
      class="panel"
      :class="'red lighten-2'"
      align-center
      justify-center
      row
      fill-height
    >
      <div class="message deftColor">
        <strong color="black" style="color:black;">No momento o Motor Fiscal não está baixando os CTEs devido a um problema na Sefaz - <a href="https://www.cte.fazenda.gov.br/portal/principal.aspx">Leia o Comunicado!</a></strong>
      </div>
      <!-- <div class="link deftColor" @click="$router.push('/fechamento')">Venha conhecer</div> -->
      <v-tooltip bottom>
        <v-btn slot="activator" icon dark @click.native="desativarNewFeatureInfoSefaz()">
          <v-icon color="red">close</v-icon>
        </v-btn>
        <span>Fechar essa notificação</span>
      </v-tooltip>
    </v-layout>
    <v-layout 
      v-if="buscaCTE"
      id="persistInfo"
      class="panel"
      :class="'yellow lighten-2'"
      align-center
      justify-center
      row
      fill-height
    >
      <div class="message deftColor">
        <strong color="black" style="color:black;">Devido a alta quantidade de notas a busca pode levar alguns minutos, agradecemos a compreensão!</strong>
      </div>
      <!-- <div class="link deftColor" @click="$router.push('/fechamento')">Venha conhecer</div> -->
      <v-tooltip bottom>
        <v-btn slot="activator" icon dark @click.native="desativarNewFeature()">
          <v-icon color="red">close</v-icon>
        </v-btn>
        <span>Fechar essa notificação</span>
      </v-tooltip>
    </v-layout>

      <v-dialog @keydown.esc="dialog = false" persistent v-model="dialog" :max-width="`${dialogWidthRC}px`">
        <v-card>
            <v-toolbar dark class="headline darkBlue">
              <v-toolbar-title >Renovar Certificado</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn icon dark @click.native="dialog=false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <article>
            <v-card-text style="width: 90%;margin: auto;" class="form_empresa_inputs">
              <CertDigitalElement :dialog="dialog" :showInfoCertificado="showInfoCertificado" />
            </v-card-text>
            </article>
          </v-card>
      </v-dialog>
  </article>
</template>

<script>
import CertDigitalElement from './CertDigitalElement.vue'
export default {
  props: ["empresa", "conta"],
  components: { CertDigitalElement },
  data: () => ({
    config: {
      show: false,
      msg: "",
      color: "",
      icon: "",
      link: { has: false, url: "", msg: "" }
    },
    mostrarNewFeatures: false,
    sefazLentidao: false,
    prefSpLentidao: false,
    InformacaoSefaz : false,
    dialog: false,
  }),
  mounted: function() {
    this.$nextTick(function() {
      
    });
  },
  watch: {
    empresa: function(newV, oldV) {
      this.reset();
      this.hasCCM();
      this.verifyCert;
    },
    "conta.notificacoes": function() {
      if(this.conta && this.conta.hasOwnProperty('notificacoes')){
        try{
          this.sefazLentidao = this.conta.notificacoes.sefazLenta;
          this.prefSpLentidao = this.conta.notificacoes.prefSPLenta;
        }catch(e){
          console.log(e);
        }
      }
      
    },
    $route: {
      deep: true,
      handler: function(refreshPage) {
        if (this.empresa) {
          this.reset();
          this.hasCCM();
          this.verifyCert;
        }
      }
    }
  },
  computed: {
    dialogWidthRC() {
      return this.$store.getters.dialogWidthRC;
    },
    buscaCTE() {
      return this.$store.state.buscaCTE;
    },
    verifyCert: function() {
      const today = new Date();
      const certDate =
        this.empresa.certificado == undefined
          ? undefined
          : new Date(this.empresa.certificado.validade);

      // let certDate = new Date("2019-02-26");
      // let dateVenc = new Date("2018-01-12T14:38:54.000Z");
      if (this.empresa.hasOwnProperty("_id")) {
        /* if(this.certificadoError() == true){
          this.configMsg(
            "Estamos com lentidão em nosso sistema! A equipe técnica já está atuando e informaremos a todos assim que estabilizar. Desculpe pelo transtorno!",
            { has: true},
            "danger",
            true
          );
        } */
        if (certDate == undefined) {
          this.configMsg(
            "Empresa não possui certificado vinculado, impossibilitando baixa de documentos fiscais!",
            { has: true, url: "/configuracoes", msg: "Cadastrar agora ?" },
            "danger",
            true
          );
        } else if (this.certVencido(certDate, today)) {
          this.configMsg(
            "Certificado expirado, impossibilitando consultas.",
            { has: true, url: "/configuracoes", msg: "Atualizar agora ?" },
            "danger",
            true
          );
        }else if (this.diffDays(certDate, today) <= 30) {
          let diasRestantes = this.diffDays(certDate, today);
          this.configMsg(
            `Certificado está próximo do vencimento(${certDate.toLocaleDateString()}),  ${diasRestantes} dias restantes.`,
            { has: true, url: "/configuracoes", msg: "Atualizar agora ?" },
            `${diasRestantes <= 7 ? "danger" : "warning"}`,
            true
          );
        } else if (this.empresa["certNaoPertence"]) {
          this.configMsg(
            `Identificamos que certificado digital não pertence a está empresa, impossibilitando baixa de documentos fiscais!`,
            { has: true, url: "/configuracoes", msg: "Atualizar agora ?" },
            `danger`,
            true
          );
        }
      }
    }
  },
  methods: {
    handleRedirectAgendaOnline: function() {
      this.dialog = true;
    },
    desativarNewFeature: function() {
      this.conta.newFeatures = false;
      this.mostrarNewFeatures = false;
    },
    desativarNewFeatureInfoSefaz: function() {
      this.conta.newFeatures = false;
      this.InformacaoSefaz = false;
    },
    hasCCM: function() {
      if (
        !this.empresa.hasOwnProperty("ccm") &&
        this.$router.currentRoute.path.indexOf("NFSe") != -1
      ) {
        this.configMsg(
          `Para consultar NFS-e - Emitida é necessário cadastrar a Inscrição Municipal.`,
          { has: true, url: "/configuracoes", msg: "Cadastrar agora ?" },
          "warning",
          true
        );
      }
    },
    begin: function() {},
    reset: function() {
      this.config.show = false;
      this.config.msg = "";
      this.config.color = "";
      this.config.icon = "";
      this.config.link = { has: false, url: "", msg: "" };
    },
    diffDays: function(certDate, today) {
      var timeDiff = Math.abs(certDate.getTime() - today.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return diffDays;
    },
    certVencido: function(certDate, today) {
      if (certDate.getTime() > today.getTime()) {
        return false;
      }
      return true;
    },
    /* certificadoError: function(){
      return true;
    }, */
    configMsg: function(msg, link, color, show) {
      this.config.msg = msg;
      if (this.ownerEmp()) {
        this.config.link.has = link.has;
        this.config.link.url = link.url;
        this.config.link.msg = link.msg;
      }
      this.config.color = color;
      this.config.show = show;
    },
    ownerEmp: function() {
      let hasEmp = false;
      let empresa = this.empresa;
      if (this.conta.admin) {
        this.conta.admin.find(item => {
          for (let prop in item) {
            if (item[prop] == empresa._id) {
              hasEmp = true;
            }
          }
          return hasEmp;
        });
      }

      return hasEmp;
    }
  }
};
</script>
<style scoped>
#persistInfo {
  position: relative;
  z-index: 2;
  height: 50px;
}
.danger {
  background-color: #a81212;
}
.warning {
  background-color: #e0a800 !important;
}
#persistInfo.warning .deftColor {
  color: black;
}
.message {
  margin-left: -96px;
}

.link {
  cursor: pointer;
  margin-left: 5px;
  font-weight: 600;
  text-decoration: underline;
}
.deftColor {
  color: wheat;
}
.redirectAgendaDiv {
  margin-left: 3rem;
}

.redirectAgendaDiv button {
  background: teal!important;
  color: white;
  transition: filter .2s;
}

.redirectAgendaDiv button:hover {
  cursor: pointer;
  filter: brightness(.92);
}


</style>


// WEBPACK FOOTER //
// src/components/menu/persistInfo/PersistInfo.vue